import React from 'react';
import { connect } from 'react-redux';
import { PatientCareCenterNoteNavAnchor, PatientCareCenterNoteSection } from 'PatientCareCenter/Note';
import styles from './History.module.css';
import { DBDateField, DBTextArea, DBTextField, DBRadioButton } from '_components';

class PatientCareCenterNoteWpSubjectiveHistory extends React.Component {

    render() {
        return (
            <PatientCareCenterNoteSection id='subj_history' name='History' level={5}>
                 <PatientCareCenterNoteNavAnchor id='subj_hist' /> 

                <div className={styles.date_wrapper}>
                    <label className={styles.onset_label_notreq}>Onset Date:</label>
                    <span className={styles.date_field_onSet}>
                        <DBDateField
                            noteId={this.props.noteId}
                            entity='CPEPISODE'
                            entityKeyColumn='EPNO'
                            entityKeyValue={this.props.epno}
                            maxDate={new Date()}
                            field='EPDTONST'
                        />
                    </span>

                    <label className={styles.hospital_label}>Most Recent Surgery Date:</label>
                    <span className={styles.date_field}>
                        <DBDateField
                            noteId={this.props.noteId}
                            entity='PTEVAL'
                            entityKeyColumn='EVNO'
                            entityKeyValue={this.props.evno}
                            maxDate={new Date()}
                            field='EVSUBHISHOSPDCDATE'
                        />
                    </span>
                    <span className={styles.lightbulb_col} />
                </div> 

                <div className={styles.date_wrapper}>
                            <label className={styles.onset_label_notreq}>Type of injury:</label>
                            <div className={styles.injury_type}>
                                <DBTextField
                                    noteId={this.props.noteId}
                                    entity='PTEVAL'
                                    entityKeyColumn='EVNO'
                                    entityKeyValue={this.props.evno}
                                    field='EVSUBHISINJURYTYPE'
                                    className={styles.txt_injury_type}
                                />
                            </div>
                        </div>

                 <PatientCareCenterNoteNavAnchor id='subj_hist_details' /> 
                 <div className={styles.details_wrapper} id='subj_hist_details'>
                    <label className={styles.details_label}>Work Injury Details:</label>
                    <DBTextArea
                        rows={5}
                        className={styles.details_field}
                        noteId={this.props.noteId}
                        entity='PTEVAL'
                        entityKeyColumn='EVNO'
                        entityKeyValue={this.props.evno}
                        field='EVSUBHISDETAILS'
                    />

                </div> 
                <div className={styles.details_wrapper} id='subj_hist_details'>
                    <label className={styles.details_label_not_req}>Past Medical History:</label>
                    <DBTextArea
                        rows={5}
                        className={styles.details_field}
                        noteId={this.props.noteId}
                        entity='PTEVAL'
                        entityKeyColumn='EVNO'
                        entityKeyValue={this.props.evno}
                        field='EVSUBHISPMH'
                    />

                </div> 
                <div className={styles.radio_row}>
                    <label className={styles.label_col_req}>Dominant Arm:</label>
                    <DBRadioButton
                        noteId={this.props.noteId}
                        entity='PTEVAL'
                        entityKeyColumn='EVNO'
                        entityKeyValue={this.props.evno}
                        field='EVSUBMEDDOMARM'
                        label='Left'
                        selectedValue='Left'
                        className={styles.radio_col}
                    />
                    <DBRadioButton
                        noteId={this.props.noteId}
                        entity='PTEVAL'
                        entityKeyColumn='EVNO'
                        entityKeyValue={this.props.evno}
                        field='EVSUBMEDDOMARM'
                        label='Right'
                        selectedValue='Right'
                        className={styles.radio_col}
                    />
                    <DBRadioButton
                        noteId={this.props.noteId}
                        entity='PTEVAL'
                        entityKeyColumn='EVNO'
                        entityKeyValue={this.props.evno}
                        field='EVSUBMEDDOMARM'
                        label='Both'
                        selectedValue='Both'
                        className={styles.radio_col}
                    />
                </div>
              
                <PatientCareCenterNoteNavAnchor id='subj_medhis_involvedside' />

                <div className={styles.radio_row} id='subj_medhis_involvedside'>
                    <label className={styles.label_col_req}>Involved Side:</label>
                    <DBRadioButton
                        noteId={this.props.noteId}
                        entity='PTEVAL'
                        entityKeyColumn='EVNO'
                        entityKeyValue={this.props.evno}
                        field='EVSUBMEDINVOLVEDSIDE'
                        label='Left'
                        selectedValue='Left'
                        className={styles.radio_col}
                    />
                    <DBRadioButton
                        noteId={this.props.noteId}
                        entity='PTEVAL'
                        entityKeyColumn='EVNO'
                        entityKeyValue={this.props.evno}
                        field='EVSUBMEDINVOLVEDSIDE'
                        label='Right'
                        selectedValue='Right'
                        className={styles.radio_col}
                    />
                    <DBRadioButton
                        noteId={this.props.noteId}
                        entity='PTEVAL'
                        entityKeyColumn='EVNO'
                        entityKeyValue={this.props.evno}
                        field='EVSUBMEDINVOLVEDSIDE'
                        label='Both'
                        selectedValue='Both'
                        className={styles.radio_col}
                    />
                    <DBRadioButton
                        noteId={this.props.noteId}
                        entity='PTEVAL'
                        entityKeyColumn='EVNO'
                        entityKeyValue={this.props.evno}
                        field='EVSUBMEDINVOLVEDSIDE'
                        label='N/A'
                        selectedValue='N/A'
                        className={styles.radio_col}
                    />
                </div>
            </PatientCareCenterNoteSection >
        );
    }

}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let evno = parseInt(noteId.split("_")[1]);
    let ntno = parseInt(noteId.split("_")[0]);

    let evpno = Object.keys(state.entities.notes.PTEVALPEDS)
        //peds info
        .find(key => (state.entities.notes.PTEVALPEDS[key].EVPEVNO === evno));

    let epno = state.entities.admissions[state.entities.notes.PTEVAL[evno].EVEPNO]?.id;

    return {
        noteId: noteId,
        evno: evno,
        epno: epno,
        ntno,
        evpno,
    };
}

const connectedPatientCareCenterNoteWpSubjectiveHistory = connect(mapStateToProps)(PatientCareCenterNoteWpSubjectiveHistory);
export { connectedPatientCareCenterNoteWpSubjectiveHistory as PatientCareCenterNoteWpSubjectiveHistory };

